import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import axios from "axios";
import { useCliente } from "../context/ClienteContext";

const EditarSessaoAula = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const { parametros } = useCliente();

  const [nome, setNome] = useState("");
  const [resumo, setResumo] = useState("");
  const [disciplinas, setDisciplinas] = useState([]);
  const [disciplinasSelecionadas, setDisciplinasSelecionadas] = useState([]);
  const [mensagem, setMensagem] = useState("");

  const professorId = localStorage.getItem("user_id");

  useEffect(() => {
    const carregarDados = async () => {
      try {
        // Dados da sessão
        const respostaSessao = await axios.get(`/api/sessoes_aula/${id}`);
        const dados = respostaSessao.data;
        setNome(dados.nome);
        setResumo(dados.resumo);
        setDisciplinasSelecionadas(dados.disciplinas.map((d) => d.id));

        // Disciplinas do professor
        const respostaDisciplinas = await axios.get(`/api/disciplinas/professor/${professorId}`);
        setDisciplinas(respostaDisciplinas.data);
      } catch (error) {
        console.error("Erro ao carregar dados:", error);
      }
    };

    carregarDados();
  }, [id, professorId]);

  const handleDisciplinaCheckbox = (id) => {
    setDisciplinasSelecionadas((prev) =>
      prev.includes(id) ? prev.filter((d) => d !== id) : [...prev, id]
    );
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await axios.put(`/api/sessoes_aula/${id}`, {
        professor_id: professorId,
        nome,
        resumo,
        disciplinas_ids: disciplinasSelecionadas,
      });
      setMensagem("Sessão atualizada com sucesso!");
      setTimeout(() => navigate(`/sessao/${id}?origem=listagem`), 1000);
    } catch (error) {
      console.error("Erro ao atualizar sessão:", error);
      alert("Erro ao salvar sessão.");
    }
  };

  return (
    <div className="form-wrapper">
      <h2 className="form-title">Editar Sessão de Aula</h2>

      {mensagem && <div className="sucesso-msg">{mensagem}</div>}

      <form onSubmit={handleSubmit}>
        <div className="form-group">
          <label>Nome da Sessão</label>
          <input
            type="text"
            value={nome}
            onChange={(e) => setNome(e.target.value)}
            required
          />
        </div>

        <div className="form-group" style={{ marginTop: "18px" }}>
          <label>Disciplinas em que a sessão se aplica</label>
        </div>

        {disciplinas.length > 0 ? (
          <div style={{ overflowX: "auto", marginTop: "10px" }}>
            <table className="tabela" style={{ fontSize: "0.75rem" }}>
              <thead style={{ backgroundColor: parametros?.cor_cabecalho || "#156082", color: "white" }}>
                <tr>
                  <th style={{ width: "20%", textAlign: "left", padding: "10px" }}>Código</th>
                  <th style={{ width: "65%", textAlign: "left", padding: "10px" }}>Nome</th>
                  <th style={{ width: "15%", textAlign: "center", padding: "10px" }}>Selecionar</th>
                </tr>
              </thead>
              <tbody>
                {disciplinas.map((disciplina) => (
                  <tr key={disciplina.id}>
                    <td style={{ padding: "10px" }}>{disciplina.codigo}</td>
                    <td style={{ padding: "10px" }}>{disciplina.nome}</td>
                    <td style={{ textAlign: "center", padding: "10px" }}>
                      <input
                        type="checkbox"
                        checked={disciplinasSelecionadas.includes(disciplina.id)}
                        onChange={() => handleDisciplinaCheckbox(disciplina.id)}
                      />
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        ) : (
          <p>Nenhuma disciplina disponível.</p>
        )}

        <div className="form-group full-width" style={{ marginTop: "18px" }}>
          <label>Resumo da sessão:</label>
          <textarea
            value={resumo}
            onChange={(e) => setResumo(e.target.value)}
            rows={6}
            required
            style={{ fontSize: "0.65rem", padding: "10px" }}
          ></textarea>
        </div>

        <div className="form-actions">
          <button type="button" className="btn btn-secondary" onClick={() => navigate(-1)}>
            Voltar
          </button>
          <button type="submit" className="btn btn-primary">Salvar Alterações</button>
        </div>
      </form>
    </div>
  );
};

export default EditarSessaoAula;
